angular.module('ui2.0Controllers').controller('moveDocumentController', ['$scope', '$uibModal', '$rootScope', '$location', '$templateCache', '$compile', '$timeout', '$http', '$window', '$anchorScroll', 'urlFactory', '$routeParams', '$sce', '$document', '$route', '$filter', '$q', function ($scope, $modal, $rootScope, $location, $templateCache, $compile, $timeout, $http, $window, $anchorScroll, urlFactory, $routeParams, $sce, $document, $route, $filter, $q) {
    $scope.moveDocPostData = {
        "documentContract": {},
        "suppliers": {}
    };
    $scope.errorObj = {};
    $scope.init = () => {
        let _tempIds = $scope.moveDocumentData.docId.split('_');
        $scope.parentContractId = _tempIds[0];
        $scope.docId = _tempIds[1];
    }
    $scope.getFieldLayout = (args) => {
        let {name,id,label,type} = args || {}
        return {
            "id": id,
            "name": name,
            "label": label,
            "type": type,
            "orderSeq": 10,
            "properties": {},
            "displayMode": "editable",
            "dynamicField": false,
            "editableHtmlType": 3,
            "autoComplete": false,
            "enableListView": false,
            "bulkEditable": false,
            "multiEntitySupport": false
        }
    }
    $scope.isMoveDocument = true;
    $scope.fieldLayoutData = {
        "documentContract": $scope.getFieldLayout({id:12030,name: "moveDocumentContract", label: "Document",type: "select"}) ,
        "suppliers": $scope.getFieldLayout({id:12035,name: "moveDocumentSupplier", label: "Supplier",type: "select"})
    };
    $scope.init();
    $scope.moveDocumentPopupObj = {
        popUpTitle: 'Move Document',
        moveDocument: true,
        labelA: intl_msg[31353] || 'Choose contract to move the document. Child documents of the selected document will also get moved.'
    };

    $scope.moveDocument = () => {
        if(!_.get($scope.moveDocPostData,'documentContract.values.id')) {
            !_.get($scope.moveDocPostData,'suppliers.values.id') && ($scope.errorObj['suppliers'] = true);
            $scope.errorObj['documentContract'] = true;
            return;
        }
        let postData = {
            contractDocument: parseInt($scope.docId),
            fromContract: parseInt($scope.parentContractId),
            toContract: _.get($scope.moveDocPostData,'documentContract.values.id')
        }
        startLoader();
        var promise = requestData("POST", '/contract/document/move', postData);
        promise.success(function (data) {
            stopLoader();
            if (data.header && data.header.response && (data.header.response.status == "error" || data.header.response.status == "applicationError")) {
                let errorMsg = "Something went wrong",
                    htmlError="<p class='beginErr'>"+errorMsg+"</p>",
                    header = "NOTIFICATION";
                if(_.get(data,'body.errorMessages') || _.get(data,'header.response.errorMessage')){
                    errorMsg = _.get(data,'body.errorMessages') || _.get(data,'header.response.errorMessage');
                    htmlError="<p class='beginErr'>"+errorMsg+"</p>";
                }
                SirionUtils.openSirionDialogs({popupType: 'alert', str: htmlError, heading: header});
            }else if (_.get(data,'errorMessages.length')) {
                let arr = data.errorMessages;
                let htmlError= "Something went wrong";
                if(arr.length == 1){
                    htmlError = '';
                    htmlError+=arr[0]["errorMessage"];
                }else{
                    htmlError = '';
                    for(var i = 0;i<arr.length;i++){
                        htmlError+="<p class='errorLine'><span class='sno'>"+(i+1)+". </span><span class='textSpan'>"+arr[i]["errorMessage"]+"</span></p>";
                    }
                }
                Toaster.create(htmlError,{iconClass:"icon-Information_filled"});
            } else if (data &&  data.status == "success") {
                Toaster.create("Success");
                $scope.moveDocumentDialogInstance.close();
            }
    });

    }

    $scope.$on("$destroy",function(e){
        $scope.isMoveDocument = false;
    });

}]);
